import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from 'src/app/services/report.service';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { MaintenanceManager } from 'src/app/classes/maintenance-manager';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-maintenance-report',
  templateUrl: './maintenance-report.component.html',
  styleUrls: ['./maintenance-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class MaintenanceReportComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data = [];
  loading:boolean = false;
  total:number = 0;
  totalDiscount:number = 0;

  constructor(private repServ:ReportService, private maintenanceMan:MaintenanceManager) {
    this.date1.setDate(this.date1.getDate() - 30);
  }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.repServ.maintenanceReport(this.date1, this.date2)
      .then(resp => {
        this.data = resp;
        this.alldata = resp;
        this.filter();
        this.loading = false;
      });
  }

  getTotal(iva = true) {
    let total = 0;
    for (let i = 0; i < this.data.length; i++) {
      total += iva ? this.data[i].totalTotal : this.data[i].totalPrice;
    }
    return total;
  }

  download(type) {
    const params = new URLSearchParams();

    params.append('date1', this.date1.toString());
    params.append('date2', this.date2.toString());

    if (this.selectedUnit && this.selectedUnit > 0) {
      params.append('unit', this.selectedUnit.toString());
    }

    if (this.selectedArticle && this.selectedArticle.trim() !== '') {
      params.append('article', this.selectedArticle.toString());
    }

    const url = `${environment.baseUrl}/${type}/maintenance?${params.toString()}`;

    window.open(url, '_blank');
    // window.open(environment.baseUrl + '/' + type + '/maintenance' + '?date1=' + this.date1.toString() + '&date2=' + this.date2.toString(), '_blank')
  }

    
  alldata = [];
  selectedUnit:any = null;
  selectedArticle:any = '';
  filter() {
    const search = (this.selectedArticle || '').trim().toUpperCase();

    this.data = this.alldata
      .map((value: any) => {

        var filteredInfo = value.info.filter((item: any) => {
          const matchUnity = this.selectedUnit ? item.unity_id == this.selectedUnit : true;
          const matchText = search
            ? ((item.article_name || '') + ' ' + (item.description || '')).toUpperCase().includes(search) : true;

          return matchUnity && matchText;
        });

        let quantity = 0;
        let total = 0;
        let totalPrice = 0;
        let totalDiscount = 0;

        filteredInfo = [...filteredInfo].sort((a, b) => a.id - b.id);
        let order_id = -1;

        filteredInfo.forEach((item: any) => {
          quantity += Number(item.quantity);
          total += Number(item.quantity) * (1 + Number(item.iva)) * Number(item.price);
          totalPrice += Number(item.quantity) * Number(item.price);

          if (item.id !== order_id) {
            order_id = item.id;
            totalDiscount += Number(item.discount);
          }
        });


        return {
          ...value,
          info: filteredInfo,
          quantity,
          total,
          totalPrice,
          totalDiscount,
          totalTotal: total - totalDiscount
        };
      }).filter((value: any) => value.info.length > 0);
  }



}
